import { FC, useEffect } from "react";
import Stack from "@mui/material/Stack";
import { useSearchParams } from "react-router-dom";
import { useEffectOnceWhen } from "rooks";
import { AzureReservationsMetadata } from "./components/metaData/AzureReservationsMetadata";
import { AzureReservationsDrawers } from "./components/drawers/AzureReservationsDrawers";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { commitmentsCurrentOrgIdSelector } from "@/store/commitments/selectors/common/commitmentsCurrentOrgIdSelector";
import { getAzureReservationsThunk } from "@/store/commitments/thunks/azure/reservations/getAzureReservationsThunk";
import { AzureReservationsDataGrid } from "@/components/pages/commtiments/azure/reservations/components/content/data-grid/AzureReservationsDataGrid";
import { DataViewTab } from "@/store/commitments/utils/types/types";
import {
  setCommitmentsCoverageFilters,
  setCommitmentsDataViewTab,
} from "@/store/commitments/commitmentsSlice";
import { urlToObject } from "@/components/utils/helpers/dataToUrlToDataConvertors";
import { changeCommitmentDateRangeThunk } from "@/store/commitments/thunks/changeCommitmentDateRangeThunk";

export const AzureReservations: FC = () => {
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();

  const dataViewTabFromParams = searchParams.get("view_tab") as DataViewTab;
  const datesPathFromParams = searchParams.get("dates");
  const orgId = useAppSelector(commitmentsCurrentOrgIdSelector);

  useEffect(() => {
    dispatch(setCommitmentsCoverageFilters(null));
    dispatch(getAzureReservationsThunk());
  }, [dispatch, orgId]);

  useEffectOnceWhen(() => {
    dispatch(setCommitmentsDataViewTab(dataViewTabFromParams));
  }, !!dataViewTabFromParams);

  useEffectOnceWhen(() => {
    const dates = urlToObject(datesPathFromParams);

    if (dates) {
      dispatch(changeCommitmentDateRangeThunk({ dates }));
    }
  }, !!datesPathFromParams);

  return (
    <Stack gap={1.5} flex={1} pt={1.5}>
      <AzureReservationsMetadata />
      <AzureReservationsDataGrid />

      <AzureReservationsDrawers />
    </Stack>
  );
};
